import {
  PRESUPUESTADOR_GET_PERITAJE_BEGIN,
  PRESUPUESTADOR_GET_PERITAJE_FAILURE,
  PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
  PRESUPUESTADOR_GET_PERITAJE_DISMISS_ERROR
} from '../constants';
import { ESTADO } from '../../MainPresupuestador.constants';


export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_PERITAJE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.data) {
            return {
              ...usado,
              pending: true,
              error: null,
            }
          } else {
            return usado
          }
        }),
      }

    case PRESUPUESTADOR_GET_PERITAJE_SUCCESS: {
      // The request is success
      const peritaciones = action.data?.peritaje
        ? {
          ...state.peritaciones,
          [action.data.peritaje.servicePatent]: action.data.peritaje,
        }
        : state.peritaciones
      const entregaUsados = state.entregaUsados.map((usado) => {
        if (usado.patente === action.patente) {
          if ((action.data && !action.isModoVer) || (action.data && action.isModoVer && state.state === ESTADO.RESERVADO)) {
            return {
              ...action.data.usado,
              pending: false,
              error: null,
              peritado: action.data.peritaje.statusId,
              requestsId: action.data.peritaje.id,
              assesed: action.data.peritaje.statusId,
            }
          } else if (action.data?.usado) {
            return {
              ...usado,
              pending: false,
              error: null,
              appraisal_approved: action.data.usado.appraisal_approved,
            }
          } else {
            return {
              ...usado,
              pending: false,
              error: null,
            }
          }
        }
        else {
          return {
            ...usado,
            pending: false,
            error: null,
          }
        }
      })
      return {
        ...state,
        peritaciones,
        entregaUsados,
      }
    }

    case PRESUPUESTADOR_GET_PERITAJE_FAILURE:
      // The request is failed
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.patente) {
            return {
              ...usado,
              pending: false,
              error: action.data.error,
            }
          } else {
            return usado
          }
        }),
      }

    case PRESUPUESTADOR_GET_PERITAJE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.patente) {
            return {
              ...usado,
              pending: false,
              error: null,
            }
          } else {
            return usado
          }
        }),
      }

    default:
      return state
  }
}